import { Schema } from "@comparaonline/products-schema";
import { hasReviewSummary } from "./hasReviewSummary";

type GetReviewSummary = (
  product: Schema.ProductListProduct
) => Pick<Schema.ProductListReviews, "total" | "averageValue"> | null;
export const getReviewSummary: GetReviewSummary = product =>
  hasReviewSummary(product)
    ? { total: product.reviews!.total, averageValue: product.reviews!.averageValue }
    : null;
